import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { RangeBar } from '@antv/g2plot'
import { ShiftDetailVO, ShiftDetailDTO, ShiftVO } from '@/service-proxies/app-v2/time.service-proxies'
import { format } from '../utils'
import { state } from '../store'
import { Reactive } from '@/utils/decorators'

@Component
export default class ShiftChart extends Vue {
  @Reactive(state) readonly currentModelDetail: ShiftVO = null
  id = `shift-chart-${Date.now()}`
  plot: RangeBar = null

  get lang() {
    return (this.$store.state as any).i18n.lang
  }

  @Watch('lang')
  reRender() {
    this.plot.destroy()
    this.renderChart(this.currentModelDetail.shiftDetailVOList)
  }

  @Watch('currentModelDetail', { deep: true })
  updateChart(val: ShiftVO) {
    this.plot.destroy()
    this.renderChart(val.shiftDetailVOList)
  }

  mounted() {
    this.renderChart(this.currentModelDetail.shiftDetailVOList)
  }

  formatData(originalData: ShiftDetailVO[]) {
    const restTime = []
    const workTime = originalData.map(item => {
      item.shiftRestTimeVOList.forEach((ite, inde) => {
        restTime.unshift({
          shift: item.indexName || `${this.$t('page_shift_model_shift')}${item.shiftIndex}`,
          values: [ite.restStartTime, ite.restEndTime],
          // color: 'grey',
          type: `${this.$t('page_shift_model_rest')}${ite.restIndex || inde + 1}`,
        })
      })
      return {
        shift: item.indexName || `${this.$t('page_shift_model_shift')}${item.shiftIndex}`,
        values: [item.shiftStartTime, item.shiftEndTime],
        // color: 'blue',
        type: `${this.$t('page_shift_model_range')}`,
      }
    })
    // console.log(restTime.concat(workTime))
    return restTime.concat(workTime)
  }

  initChart(data) {
    return new RangeBar(document.getElementById(this.id), {
      data,
      meta: {
        shift: {
          alias: this.$t('page_shift_model_shift') as string,
        },
        values: {
          alias: this.$t('page_shift_model_range') as string,
        },
      },
      xField: 'values',
      yField: 'shift',
      xAxis: {
        label: {
          visible: true,
          formatter: (name, tick, index) => {
            return format(Number(name))
          },
        },
        line: {
          visible: true,
        },
        tickLine: {
          visible: true,
        },
        tickInterval: 120,
        min: this.currentModelDetail.startTime,
        max: this.currentModelDetail.endTime,
      },
      colorField: 'type',
      label: {
        visible: false,
      },
      tooltip: {
        formatter: (vals, _, title) => {
          return {
            name: title,
            value: `${format(vals[0])} - ${format(vals[1])}`,
          } as any
        },
      },
    })
  }

  renderChart(originalData: ShiftDetailVO[]) {
    const data = this.formatData(originalData)
    this.plot = this.initChart(data)
    // console.log(this.plot)
    this.plot.render()
  }

  render() {
    return <div id={this.id} style="width: 100%; height: 360px; border: 1px solid #eee;"></div>
  }
}
